/**
 * 전역 로딩 진행 표시(상단 바)용 pub/sub.
 * - axios 인터셉터(API 요청)와 Suspense fallback(lazy 청크 로딩)이 start()/done() 호출
 * - GlobalProgressBar 가 subscribe 해서 상단 바를 표시
 * 동시 요청은 count 로 누적 → 0→1(활성 시작), 1→0(전부 종료) 전환에서만 통지한다.
 */
let count = 0;
const listeners = new Set();

function emit(active) {
    listeners.forEach((fn) => fn(active));
}

const progressBus = {
    start() {
        count += 1;
        if (count === 1) emit(true);
    },
    done() {
        if (count === 0) return;
        count -= 1;
        if (count === 0) emit(false);
    },
    isActive() {
        return count > 0;
    },
    subscribe(fn) {
        listeners.add(fn);
        return () => listeners.delete(fn);
    },
};

export default progressBus;
